<script lang="ts" setup>
import type { LoadingListRoute } from '@/types/cargo-loading'

import { useI18n } from 'vue-i18n'
import axios from 'axios'
import { useRoute, useRouter } from 'vue-router'
import { onMounted, ref, watch } from 'vue'

import { ResourceResponse } from '@/types/general'
import { useAuthStore } from '@/stores/auth-store'

import MyModal from '@/components/my-components/MyModal.vue'
import RouteCard from '@/components/cargo-loading/RouteCard.vue'
import ContentHeading from '@/components/layout/ContentHeading.vue'
import LoaderWrapper from '@/components/loaders/LoaderWrapper.vue'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()

const loadingListRoute = ref<LoadingListRoute | null>(null)
const loading = ref(false)

async function fetchRoute() {
    const routeId = route.params.routeId

    if (!routeId) return

    loading.value = true
    try {
        const response = await axios.get<ResourceResponse<LoadingListRoute>>(
            window.route('cl.company.loading-list-routes.show', {
                company: authStore.companyId,
                loading_list_route: routeId,
            }),
        )

        loadingListRoute.value = response.data.data
    } finally {
        loading.value = false
    }
}

function onClose() {
    router.replace({ name: 'cl.routes.index', query: route.query })
}

onMounted(fetchRoute)
watch(() => route.params.routeId, fetchRoute)
</script>

<template>
    <MyModal :model-value="true" :max-width="1200" @close="onClose">
        <LoaderWrapper :visible="loading" />

        <ContentHeading v-if="loadingListRoute">
            <h1 class="text-xl font-bold text-primary-400">
                {{ t('route') }} – {{ loadingListRoute?.carrierNumber }}
            </h1>
        </ContentHeading>

        <RouteCard
            v-if="loadingListRoute"
            class="mt-4"
            :route="loadingListRoute"
            :destination="loadingListRoute.destinationPort.shortName"
        />
    </MyModal>
</template>
